// Paleta exacta del diseño de referencia.
// Vive en Constants (y no en una página) porque la consumen componentes
// globales de src/Components; Components nunca debe importar de Pages.
export const palette = {
  ink: '#12211a',
  muted: '#5b6b62',
  green: '#0a7441',
  amber: '#b45309',
  border: '#e9edeb',
  borderSoft: '#eef2f0',
  track: '#e4efe7',
};

export default palette;
